module.exports = __webpack_public_path__ + "img/logo-ga-white.881416c6.svg";